import React from 'react';
import styles from "./styles.module.scss";
interface IProps {
    value: string|any,
    onChange: Function|any,
    name: string
}

const Input : React.FC<IProps> = ({ value, onChange, name }) => {
    return (
        <div>
            <input
                autoComplete={'off'}
                className={ styles.input }
                name={name}
                value={value}
                onChange={onChange}
                placeholder="Vui lòng nhập"
            />
        </div>
    );
}

export default Input;
